import apiClient from "./client";

// Field-level change history for a record (Enhanced Audit Trail).
// Returns an array of history items, newest first:
//   { auditChangeLogId, changedDateTime, changedBy, action, summary, changes: [...] }
export function fetchAuditHistory(entityType, recordId) {
  return apiClient
    .get(`/audit-changes/${encodeURIComponent(entityType)}/${encodeURIComponent(recordId)}`)
    .then((res) => res.data);
}

// Download the change history as CSV (returns a Blob).
export function exportAuditHistory(entityType, recordId) {
  return apiClient
    .get(`/audit-changes/${encodeURIComponent(entityType)}/${encodeURIComponent(recordId)}/export`, {
      responseType: "blob",
    })
    .then((res) => res.data);
}
